export const TeamIndexSceneTranslation = {
  fi: {
    TeamIndexScene: {
      title: 'Tiimi',
      add: 'Lisää',
      deletePrompt: 'Haluatko todella poistaa tämän käyttäjän?',
      faultReportsOnly: 'Vain vikailmoitukset',
      yes: 'Kyllä',
    },
  },
};
